import React from 'react';
import PropTypes from 'prop-types';

import http from 'api/http';
import { boatAPI } from 'api/requests';

import Select, { selectType } from 'Components/Select';
import { ACTION } from '../../../constants';

export default class Row extends React.Component {
  state = {
    rowData: {},
    rowDataRequestInProcess: true,
  };

  componentDidUpdate() {
    const { rowData } = this.state;
    const { expandedRowId, boat } = this.props;

    if (expandedRowId === boat.id && !Object.keys(rowData).length) {
      http.get(boatAPI.details(boat.id)).then(({ data: rowData }) => {
        this.setState({ rowDataRequestInProcess: false, rowData });
      });
    }
  }

  _getRowState = () => {
    const { expandedRowId, boat } = this.props;

    return expandedRowId === boat.id ? 'expanded' : 'collapsed';
  };

  _getStatusColor = () => {
    const { boat } = this.props;

    if (boat && boat.status) {
      return `list-scene__status-label_${boat.status.toString().toLowerCase()}`;
    }
    return '';
  };

  _getTrailerReadableStatus = () => {
    const { boat } = this.props;

    if (boat && boat.status) {
      return boat.status[0].toUpperCase() + boat.status.slice(1).toLowerCase();
    }

    return '';
  };

  _getTextColourStyle = key => {
    const { sortedBy } = this.props;

    if (sortedBy === key) return 'active';
    return '';
  };

  _getBackgroundColourStyle = () => {
    const { isOdd } = this.props;

    return isOdd ? '_background_color_pale_gray' : '_background_color_white';
  };

  _getAdditionalRowStyles = () => {
    const { expandedRowId, boat } = this.props;

    let classes = '_overflow_hidden ';
    classes += expandedRowId === boat.id ? '_expanded _height_60' : '_collapsed _height_0';

    return classes;
  };

  _getSpeedValue = () => {
    const { rowData } = this.state;

    return !Object.keys(rowData).length ? (
      <div className='ect-spinner'>
        <figure className='ect-spinner__image' />
      </div>
    ) : rowData.maxSpeedLessThan30 ? (
      '<30  Mph.'
    ) : rowData.passesTestAtFullPower ? (
      '>30 Mph.'
    ) : rowData.maneuveringSpeed ? (
      rowData.maneuveringSpeed.toFixed(2) + ' Mph.'
    ) : (
      '-'
    );
  };

  _getFixedValue = (value, units) => {
    const { rowData } = this.state;

    return !Object.keys(rowData).length ? (
      <div className='ect-spinner'>
        <figure className='ect-spinner__image' />
      </div>
    ) : value ? (
      `${value.toFixed(2)} ${units || ''}`
    ) : (
      '-'
    );
  };

  _getValue = value => {
    const { rowData } = this.state;

    return !Object.keys(rowData).length ? (
      <div className='ect-spinner'>
        <figure className='ect-spinner__image' />
      </div>
    ) : value ? (
      value
    ) : (
      '-'
    );
  };

  _getColWidth = () => {
    const { rowData } = this.state;

    return rowData.engineType === 'INBOARD' ? '_width_pc_10' : '_width_pc_11';
  };

  selectAction = action => {
    const { boat, selectAction, updateListEntry, deleteListEntry } = this.props;

    selectAction(action, boat).then(updatedData => {
      if (action !== ACTION.DELETE) updateListEntry(boat, updatedData);
      else deleteListEntry(boat);
    });
  };

  render() {
    const { rowData } = this.state;
    const { toggleRow, boat, createActionsList } = this.props;

    return (
      <section
        id={`boatListRowID${boat.id}`}
        className={`list-scene__expandable-row-wrapper list-scene__expandable-row-wrapper_${this._getRowState()}`}
      >
        <div className={`list-scene__table-row ${this._getBackgroundColourStyle()} _margin_bottom_0`}>
          <div className={`list-scene__status-bar_left ${this._getStatusColor()}`} />

          <div
            className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_8 _cursor_pointer'
            onClick={toggleRow(boat.id)}
          >
            <div className={`list-scene__expand-icon list-scene__expand-icon_${this._getRowState()}`} />
          </div>

          <div
            id='boatIdField'
            onClick={() => this.selectAction(ACTION.DETAILS)}
            className={`list-scene__table-row-element list-scene__table-row-element_text-element
            ${this._getTextColourStyle('id')} _width_pc_10`}
          >
            {boat.id}
          </div>

          <div
            id='boatNameField'
            onClick={() => this.selectAction(ACTION.DETAILS)}
            className={`list-scene__table-row-element list-scene__table-row-element_text-element
            ${this._getTextColourStyle('name')} _width_pc_36`}
          >
            {boat.name}
          </div>

          <div
            id='boatTypeField'
            onClick={() => this.selectAction(ACTION.DETAILS)}
            className={`list-scene__table-row-element list-scene__table-row-element_text-element
            ${this._getTextColourStyle('name')} _width_pc_12`}
          >
            {boat.boatType ? boat.boatType.replace(/_/g, ' ') : ''}
          </div>

          <div
            id='boatEngineTypeField'
            onClick={() => this.selectAction(ACTION.DETAILS)}
            className={`list-scene__table-row-element list-scene__table-row-element_text-element
            ${this._getTextColourStyle('name')} _width_pc_12`}
          >
            {boat.engineType ? boat.engineType.replace(/_/g, ' ') : ''}
          </div>

          <div
            className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_10'
            onClick={() => this.selectAction(ACTION.DETAILS)}
          >
            <div
              id='boatStatusField'
              className={`list-scene__status-label ${this._getStatusColor()} ${this._getTextColourStyle('status')}`}
            >
              {this._getTrailerReadableStatus()}
            </div>
          </div>

          <div
            id='boatActionsField'
            className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_28'
          >
            <Select
              placeholder='Actions'
              selectionList={createActionsList(boat)}
              multiSelect
              handleSelect={this.selectAction}
              type={selectType.listActions}
            />
          </div>

          <div className={`list-scene__status-bar_right ${this._getStatusColor()}`} />
        </div>

        <div
          className={`ect-list__row_expandable _flex ${this._getAdditionalRowStyles(
            boat.id
          )} _background_color_simple_gray`}
        >
          <div className=' _height_pc_100 _width_20'>
            <div className='_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1' />
            <div className='_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center' />
          </div>
          <div className={` ${this._getColWidth()} _height_pc_100`}>
            <div className='_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'>
              Max Speed
            </div>
            <div id='boatMaxSpeedField' className='_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'>
              {this._getSpeedValue()}
            </div>
          </div>
          <div className={` ${this._getColWidth()} _height_pc_100`}>
            <div className='_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'>
              HP
            </div>
            <div id='boatMaxHPField' className='_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'>
              {this._getFixedValue(rowData.apprMaxHP)}
            </div>
          </div>
          <div className={` ${this._getColWidth()} _height_pc_100`}>
            <div className='_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'>
              HP w/o Remote
            </div>
            <div
              id='boatMaxHPWithoutRemoteField'
              className='_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'
            >
              {this._getFixedValue(rowData.apprMaxHPDualSteering)}
            </div>
          </div>
          <div className={` ${this._getColWidth()} _height_pc_100`}>
            <div className='_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'>
              Persons
            </div>
            <div
              id='boatMaxPersonsField'
              className='_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'
            >
              {this._getValue(rowData.appMaxNumberOfPersons)}
            </div>
          </div>
          <div className={` ${this._getColWidth()} _height_pc_100`}>
            <div className='_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'>
              Person Wgt
            </div>
            <div
              id='boatMaxPersonsWeightField'
              className='_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'
            >
              {this._getFixedValue(rowData.appMaxPersonsWeight, 'Lbs.')}
            </div>
          </div>
          <div className={` ${this._getColWidth()} _height_pc_100`}>
            <div className='_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'>
              Max Weight
            </div>
            <div
              id='boatMaxWeightField'
              className='_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'
            >
              {this._getFixedValue(rowData.appMaxWeight, 'Lbs.')}
            </div>
          </div>
          {rowData.engineType === 'INBOARD' && (
            <div className={` ${this._getColWidth()} _height_pc_100`}>
              <div className='_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'>
                Engine Drive Wgt
              </div>
              <div
                id='boatEngineDriveWeightField'
                className='_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'
              >
                {this._getFixedValue(rowData.engineAndDriveWeight, 'Lbs.')}
              </div>
            </div>
          )}
          <div className={` ${this._getColWidth()} _height_pc_100`}>
            <div className='_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'>
              Boat Wgt
            </div>
            <div
              id='boarCalculatedWeightField'
              className='_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'
            >
              {this._getFixedValue(rowData.calBoatWeight, 'Lbs.')}
            </div>
          </div>
          <div className={` ${this._getColWidth()} _height_pc_100`}>
            <div className='_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'>
              Inspection Date
            </div>
            <div
              id='boatInspectionDateField'
              className='_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'
            >
              -
            </div>
          </div>
          <div className={` ${this._getColWidth()} _height_pc_100`}>
            <div className='_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1'>
              Correction Date
            </div>
            <div
              id='boatCorrectionDateField'
              className='_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center'
            >
              -
            </div>
          </div>
          <div className=' _height_pc_100 _width_20'>
            <div className='_font_size_10 _text_align_center _flex _jc_center _ai_center _color_light_gray _height_pc_40 _border_bottom_1' />
            <div className='_font_size_12 _color_gray _height_pc_60 _flex _ai_center _jc_center' />
          </div>
        </div>
      </section>
    );
  }
}

Row.propTypes = {
  boat: PropTypes.object.isRequired,
  isOdd: PropTypes.bool.isRequired,
  expandedRowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  toggleRow: PropTypes.func,
  createActionsList: PropTypes.func,
  selectAction: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/List/Row.jsx